import AddIcon from '@mui/icons-material/Add';
import Fab from "@mui/material/Fab";
import React from "react";


interface AddButtonProps {
    openDialog: () => void;
}

const AddButton: React.FC<AddButtonProps> = ({ openDialog }) => {
    return (
        <Fab
            aria-label="add"
            onClick={openDialog}
            color="primary"
            sx={{
                position: 'fixed',
                bottom: 16,
                right: 16,
            }}>
            <AddIcon />
        </Fab>
    );
};

export default AddButton;
